<template>
  <div class="interview-search-wrap">
    <div class="common-new-title" v-if="filterVisible('interview_area_text')"><span>面试报名表信息</span></div>
    <div class="box-content" v-if="filterVisible('interview_form_native')">
      <label class="form-tit">国籍</label>
      <el-input class="jm-input-common" v-model="searchData.native" />
    </div>
    <div class="box-content" v-if="filterVisible('interview_form_age')">
      <label class="form-tit">年龄</label>
      <el-input class="jm-input-common" v-model="searchData.age" />
    </div>
    <div class="box-content" v-if="filterVisible('interview_form_nowplace')">
      <label class="form-tit">现住址</label>
      <jm-areaselect v-model="searchData.nowplace"/>
    </div>
    <div class="box-content" v-if="filterVisible('interview_form_nowplace_addr')">
      <label class="form-tit">现住址详情</label>
      <el-input class="jm-input-common" v-model="searchData.nowplace_addr" />
    </div>
    <div class="box-content" v-if="filterVisible('interview_form_final_school')">
      <label class="form-tit">最终学历学校名称</label>
      <el-input class="jm-input-common" v-model="searchData.final_school" />
    </div>
    <div class="box-content" v-if="filterVisible('interview_form_final_subject')">
      <label class="form-tit">最终学历</label>
      <jm-dict-select
        class="jm-input-common"
        clearable
        dict="online.interview_education_2020"
        v-model="searchData.final_edu"
      />
    </div>
    <div class="box-content" v-if="filterVisible('interview_form_final_time')">
      <label class="form-tit">最终学历毕业时间</label>
      <el-date-picker
        class="jm-input-common"
        v-model="searchData.final_time"
        type="month"
        value-format="yyyy-MM"
        placeholder="选择日期"
      ></el-date-picker>
    </div>
    <div class="box-content" v-if="filterVisible('interview_form_japanese_major')">
      <label class="form-tit">是否日语专业</label>
      <jm-dict-select
        class="jm-input-common"
        type="dataset"
        dict-type="common"
        v-model="searchData.japanese_major"
        name="yesNo"
        clearable
      />
    </div>
    <div class="box-content" v-if="filterVisible('interview_form_art_exam')">
      <label class="form-tit">是否艺术生</label>
      <jm-dict-select
        class="jm-input-common"
        type="dataset"
        dict-type="common"
        name="yesNo"
        clearable
        v-model="searchData.art_exam"
      />
    </div>
    <div class="box-content" v-if="filterVisible('interview_form_jp_school_name')">
      <label class="form-tit">日语学习机构名称</label>
      <el-input class="jm-input-common" v-model="searchData.jp_school_name" />
    </div>
    <div class="box-content" v-if="filterVisible('interview_form_jp_level_name')">
      <label class="form-tit">日语考试名称等级</label>
      <jm-dict-select
        class="jm-input-common2"
        type="dataset"
        dict-type="interviewForm"
        name="jpExamType"
        value-type="string"
        :filter="item => item.value !== 'topik'"
        v-model="searchData.jp_level_name"
        clearable
      />
      <jm-dict-select
        v-show="searchData.jp_level_name !== 'other'"
        class="jm-input-common2"
        clearable
        type="online"
        :dict-type="jpExamLevelDictName"
        v-model="searchData.jp_level_sub_name"
      />
    </div>
    <div class="box-content" v-if="filterVisible('interview_form_jp_exam_status')">
      <label class="form-tit">日语考试参加状态</label>
      <jm-dict-select
        class="jm-input-common"
        clearable
        type="dataset"
        dict-type="interviewForm"
        name="examStatus"
        v-model="searchData.jp_exam_status"
      />
    </div>
    <div class="box-content" v-if="filterVisible('interview_form_go_to_jp_times')">
      <label class="form-tit">赴日次数</label>
      <el-input class="jm-input-common" v-model="searchData.go_to_jp_times" />
    </div>
    <div class="box-content" v-if="filterVisible('interview_form_jp_visa_applied')">
      <label class="form-tit">日本签证申请历史</label>
      <jm-dict-select
        class="jm-input-common"
        type="dataset"
        dict-type="common"
        name="yesNo"
        v-model="searchData.jp_visa_applied"
        clearable
      />
    </div>
    <div class="box-content" v-if="filterVisible('interview_form_jp_visa_type')">
      <label class="form-tit">日本签证类型</label>
      <jm-dict-select
        class="jm-input-common"
        type="dataset"
        dict-type="interviewForm"
        name="jpVisaType"
        value-type="string"
        v-model="searchData.jp_visa_type"
        clearable
      />
    </div>
    <div class="box-content" v-if="filterVisible('interview_form_go_to_jp')">
      <label class="form-tit">是否赴日</label>
      <jm-dict-select
        class="jm-input-common"
        type="dataset"
        dict-type="common"
        name="yesNo"
        clearable
        v-model="searchData.go_to_jp"
      />
    </div>
    <div class="box-content" v-if="filterVisible('interview_form_jp_rejected')">
      <label class="form-tit">日本是否拒签</label>
      <jm-dict-select
        class="jm-input-common"
        type="dataset"
        dict-type="common"
        name="yesNo"
        clearable
        v-model="searchData.jp_rejected"
      />
    </div>
    <div class="box-content" v-if="filterVisible('interview_form_japan_relatives')">
      <label class="form-tit">是否有在日亲属</label>
      <jm-dict-select
        class="jm-input-common"
        type="dataset"
        dict-type="common"
        name="yesNo"
        v-model="searchData.japan_relatives"
        clearable
      />
    </div>
    <div class="box-content" v-if="filterVisible('interview_form_applyDate')">
      <label class="form-tit">申请学期</label>
      <el-date-picker
        class="jm-input-common"
        type="month"
        placeholder="选择日期"
        value-format="yyyy-MM"
        v-model="searchData.applyDate"
      />
    </div>
    <!--
    <div class="box-content" v-if="filterVisible('interview_form_one_reg_book')">
      <label class="form-tit">全家是否一个户口本</label>
      <jm-dict-select
        class="jm-input-common"
        type="dataset"
        dict-type="common"
        name="yesNo"
        clearable
        v-model="searchData.one_reg_book"
      />
    </div>
    <div class="box-content" v-if="filterVisible('interview_form_ko_learning_gov')">
      <label class="form-tit">韩语学习机构名称</label>
      <el-input class="jm-input-common" v-model="searchData.ko_learning_gov" />
    </div>
    <div class="box-content" v-if="filterVisible('interview_form_ko_exam_level')">
      <label class="form-tit">韩语考试名称级别</label>
      <jm-dict-select
        value-type="string"
        class="jm-input-common2"
        type="dataset"
        dict-type="interviewForm"
        name="jpExamType"
        clearable
        :filter="item => item.value === 'topik' || item.value === 'other'"
        v-model="searchData.ko_exam_level"
      />
      <jm-dict-select
        v-show="searchData.ko_exam_level !== 'other'"
        class="jm-input-common2"
        type="dataset"
        dict-type="interviewForm"
        name="topik"
        clearable
        v-model="searchData.ko_exam_level_sub_name"
      />
    </div>
    <div class="box-content" v-if="filterVisible('interview_form_ko_exam_status')">
      <label class="form-tit">韩语考试参加状态</label>
      <jm-dict-select
        class="jm-input-common"
        type="dataset"
        dict-type="interviewForm"
        name="examStatus"
        clearable
        v-model="searchData.ko_exam_status"
      />
    </div>
    <div class="box-content" v-if="filterVisible('interview_form_ko_visa_applied')">
      <label class="form-tit">韩国签证申请历史</label>
      <jm-dict-select
        class="jm-input-common"
        type="dataset"
        dict-type="common"
        name="yesNo"
        clearable
        v-model="searchData.ko_visa_applied"
      />
    </div>
    <div class="box-content" v-if="filterVisible('interview_form_ko_visa_type')">
      <label class="form-tit">韩国签证类型</label>
      <jm-dict-select
        class="jm-input-common"
        type="dataset"
        dict-type="interviewForm"
        name="koVisaType"
        value-type="string"
        v-model="searchData.ko_visa_type"
      />
    </div>
    <div class="box-content" v-if="filterVisible('interview_form_ko_visa_time')">
      <label class="form-tit">韩国获签时间</label>
      <el-date-picker class="jm-input-common" v-model="searchData.ko_visa_time" />
    </div>
    <div class="box-content" v-if="filterVisible('interview_form_ko_rejected')">
      <label class="form-tit">韩国是否拒签</label>
      <jm-dict-select
        class="jm-input-common"
        type="dataset"
        dict-type="common"
        name="yesNo"
        clearable
        v-model="searchData.ko_rejected"
      />
    </div>
    -->
  </div>
</template>
<script>
import { filterVisible } from '@/utils/utils';
import { jmAreaselect } from '@/components/tool';

export default {
  name: 'InterviewSearchForm',
  model: {
    value: 'searchData',
    event: 'change'
  },
  data() {
    return {
      searchData: {}
    };
  },
  components: {
    jmAreaselect
  },
  computed: {
    jpExamLevelDictName() {
      switch (this.searchData.jp_level_name) {
        case 'jlpt':
          return 'interview_jlpt';
        case 'nat':
          return 'interview_nat';
        case 'jtest':
          return 'interview_jtest';
        case 'stbj':
          return 'interview_stbj';
        default:
          return [];
      }
    }
  },
  methods: {
    filterVisible,
    reset() {
      this.searchData = {};
    }
  },
  watch: {
    searchData: {
      handler(v) {
        this.$emit('change', v);
      },
      deep: true
    }
  }
};
</script>
<style>
  .interview-search-wrap{
    clear: both;
    padding-top: 20px;
  }
  .interview-search-wrap::after{
    clear: both;
    display: block;
    content: "";
  }
.interview-form-break {
  clear: both;
  font-size: 24px;
  padding: 5px 0;
}
</style>
